const state = {
  online: navigator.onLine,
  visibilityChangeObserver: {
    dashboard: false,
    ledger: false
  },
  subscriptionEnabled: true
}

const actions = {
}

const mutations = {
  SET_APP_ONLINE (state) {
    state.online = true
  },
  SET_APP_OFFLINE (state) {
    state.online = false
  },
  SET_VISIBILITY_CHANGE_OBSERVER_APP (state, value) {
    state.visibilityChangeObserver.app = value
  },
  SET_VISIBILITY_CHANGE_OBSERVER_DASHBOARD (state, value) {
    state.visibilityChangeObserver.dashboard = value
  },
  SET_VISIBILITY_CHANGE_OBSERVER_LEDGER (state, value) {
    state.visibilityChangeObserver.ledger = value
  }
}

export default {
  state,
  actions,
  mutations
}
